import store from '@/store'

/**
 * 定义全局按钮权限指令
 * @returns 是否有权限
 */
export default function isPermission() {
  return {
    async mounted(el, binding) {
      const permission = store.getters.getUserRole
      const { value } = binding
      const hasPermissions = permission.some(permission => {
        return Object.values(permission).some(item => {
          return value.includes(item)
        })
      })
      if (!hasPermissions) {
        el.style.display = 'none'
      }
    }
  }
}
